
import React from 'react';

import { User } from "shared/services/user.service";
import { Route, Redirect  } from 'react-router-dom'
import { PermissaoRecursos } from 'shared/services/permissao-recursos.service';

export const PrivateRoute = ({component: Component,recurso = '', ...rest }) => {
    const user = new User();
    const permisaoRecurso = new PermissaoRecursos()

    if(!user.isAuthenticated()){
        user.logout();
        return <Redirect to={'/'}/>
    }

    if(!permisaoRecurso.temPermissao(recurso))
      return <Redirect to={'/dashboard'}/>

    return (
      <Route {...rest} render={props => (
        (user.isAuthenticated() && !user.isPrimeiroAcesso() ) || rest.path === '/primeiro-acesso' ?
              <Component {...props} />
          : <Redirect to={user.isPrimeiroAcesso() ? '/primeiro-acesso' : '/'}/>
      )} />
  );
}
